import { CollectionName, CollectionVisibility } from "../registry/collection-registry"
import type { CollectionCreateSchema } from "../types/typesense"

export const templatesSchema: CollectionCreateSchema = {
  name: CollectionName.Templates,
  fields: [
    {
      name: "id",
      type: "string",
      sort: true,
      infix: true,
    },
    {
      name: "version_id",
      type: "string",
      sort: true,
      infix: true,
    },
    {
      name: "code",
      type: "string",
      sort: true,
      infix: true,
      optional: true,
    },
    {
      name: "commodities",
      type: "string[]",
      infix: true,
      facet: true,
      optional: true,
    },
    {
      name: "title",
      type: "string",
      sort: true,
      infix: true,
    },
    {
      name: "destination_market",
      type: "string",
      sort: true,
      infix: true,
      facet: true,
      optional: true,
    },
    {
      name: "displayed_description",
      type: "string",
      sort: true,
      infix: true,
      optional: true,
    },
    {
      name: "destination_countries",
      type: "string[]",
      infix: true,
      facet: true,
      optional: true,
    },
    {
      name: "exporting_country",
      type: "string",
      infix: true,
      facet: true,
      optional: true,
    },
    {
      name: "industry_access",
      type: "bool",
      infix: true,
      facet: true,
    },
    {
      name: "effective",
      type: "int64",
      sort: true,
      infix: false,
      facet: true,
      optional: true,
    },
    {
      name: "expiry",
      type: "int64",
      sort: true,
      infix: false,
      facet: true,
      optional: true,
    },
    {
      name: "certificate_type",
      type: "string",
      sort: true,
      infix: true,
      facet: true,
      optional: true,
    },
    {
      name: "major_version",
      type: "string",
      sort: true,
      infix: true,
      optional: true,
    },
    {
      name: "minor_version",
      type: "string",
      sort: true,
      infix: true,
      optional: true,
    },
    {
      name: "status",
      type: "string",
      sort: true,
      infix: true,
      optional: true,
      facet: true,
    },
    {
      name: "submission_layout",
      type: "string",
      sort: true,
      infix: true,
      facet: true,
      optional: true,
    },
    {
      name: "template_id",
      type: "string",
      sort: true,
      infix: true,
      optional: true,
    },
  ],
  visibility: CollectionVisibility.Public,
}
